export class UserInformation {
    userId: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    title: string;
    phoneNumber: string;
    isActive: boolean;
    isPDxAdmin: boolean;
}